module.exports = __webpack_public_path__ + "img/img5.b7428866.png";